import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ArrowForward as ArrowIcon } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { homeSectionPaper } from "../home/homeStyles";
import { brandFilledButtonSx } from "../../utils/brandAssets";
import { communityBuildPath, communityChallengePath } from "../../utils/community";

const FeaturedChallengeCard = ({ challenge, sport }) => {
  if (!challenge) return null;

  return (
    <Box sx={{ ...homeSectionPaper, p: 2.5 }}>
      <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: "0.14em" }}>
        {challenge.official ? "Stats.fan Official" : "Featured challenge"}
      </Typography>
      <Typography variant="h5" fontWeight={800} sx={{ mt: 0.5 }}>
        {challenge.title}
      </Typography>
      {challenge.description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, maxWidth: 640 }}>
          {challenge.description}
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
        {Number(challenge.entryCount || 0).toLocaleString()}{" "}
        {challenge.entryCount === 1 ? "entry" : "entries"}
      </Typography>
      <Box sx={{ display: "flex", gap: 1.5, mt: 2, flexWrap: "wrap" }}>
        <Button
          component={RouterLink}
          to={communityBuildPath(sport, {
            challenge: challenge.slug || challenge.id,
          })}
          variant="contained"
          endIcon={<ArrowIcon />}
          sx={brandFilledButtonSx}
        >
          Build yours
        </Button>
        <Button
          component={RouterLink}
          to={communityChallengePath(sport, challenge.slug || challenge.id)}
          variant="outlined"
        >
          View challenge
        </Button>
      </Box>
    </Box>
  );
};

export default FeaturedChallengeCard;
